const Briefcase = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 5.25C12 4.55252 12 4.20378 11.9233 3.91766C11.7153 3.1412 11.1088 2.53472 10.3323 2.32667C10.0462 2.25 9.69748 2.25 9 2.25C8.30252 2.25 7.95378 2.25 7.66766 2.32667C6.8912 2.53472 6.28472 3.1412 6.07667 3.91766C6 4.20378 6 4.55252 6 5.25M3.9 15.75H14.1C14.9401 15.75 15.3601 15.75 15.681 15.5865C15.9632 15.4427 16.1927 15.2132 16.3365 14.931C16.5 14.6101 16.5 14.1901 16.5 13.35V7.65C16.5 6.80992 16.5 6.38988 16.3365 6.06901C16.1927 5.78677 15.9632 5.5573 15.681 5.41349C15.3601 5.25 14.9401 5.25 14.1 5.25H3.9C3.05992 5.25 2.63988 5.25 2.31901 5.41349C2.03677 5.5573 1.8073 5.78677 1.66349 6.06901C1.5 6.38988 1.5 6.80992 1.5 7.65V13.35C1.5 14.1901 1.5 14.6101 1.66349 14.931C1.8073 15.2132 2.03677 15.4427 2.31901 15.5865C2.63988 15.75 3.05992 15.75 3.9 15.75Z"
      stroke="#535862"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Briefcase;
